var map = {
	"./PizzeriaTomate-logo.jpg": 24,
	"./favicons/favicon.png": 25,
	"./icons/external.svg": 26,
	"./placeholders/header.jpg": 27,
	"./placeholders/salade-cesar-300x169.jpg": 28,
	"./placeholders/salade-cesar-768x432.jpg": 29,
	"./placeholders/salade-cesar.jpg": 30,
	"./placeholders/uber-eat.jpg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;